import { render, staticRenderFns } from "./tabUsCustomsClearance.vue?vue&type=template&id=5fd6d907&scoped=true&"
import script from "./tabUsCustomsClearance.vue?vue&type=script&lang=js&"
export * from "./tabUsCustomsClearance.vue?vue&type=script&lang=js&"
import style0 from "./tabUsCustomsClearance.vue?vue&type=style&index=0&id=5fd6d907&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6d907",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd6d907')) {
      api.createRecord('5fd6d907', component.options)
    } else {
      api.reload('5fd6d907', component.options)
    }
    module.hot.accept("./tabUsCustomsClearance.vue?vue&type=template&id=5fd6d907&scoped=true&", function () {
      api.rerender('5fd6d907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabUsCustomsClearance.vue"
export default component.exports